module.exports = __webpack_public_path__ + "img/bad.c24632a3.png";